import React, {useState, useEffect} from "react";
import CancelButton from "../../../components/forms/cancelButton";
import SaveButton from "../../../components/forms/saveButton";
import QuestionCardAdmin from "../../card/questionCardAdmin";
import DateRangeFormField from "../dateRangeFormField";
import { getSurveyById, updateSurvey } from "../../../client/surveys";
import ModalAlertWarning from "../../shared/modals/modalAlertWarning";
import ModalSuccess from "../../shared/modals/modalSuccess";
import { useNavigate} from "react-router-dom";


const EditFormScreen = ({ surveyId, onBack, onFormSaved }) => {  
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState(''); 
  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: ''
  });

  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState(""); 

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false); 

  const [questions, setQuestions] = useState([]);

  const convertApiToComponentFormat = (apiSurvey) => {
    
    const convertedQuestions = apiSurvey.questions.map((apiQuestion, index) => {
      let selectedFormat;
      switch(apiQuestion.formatId) {
        case 1: selectedFormat = 1; break;
        case 2: selectedFormat = 2; break;
        case 3: selectedFormat = 3; break;
        default: selectedFormat = 2;
      }

      const componentOptions = [];
      
    if (apiQuestion.options && apiQuestion.options.length > 0) {
      apiQuestion.options.forEach((option, optIndex) => {
        // Determinar si es opción "Otros" basado en hasOtherOption
        const isOtherOption = apiQuestion.hasOtherOption && option.text === "Otros";
        
        componentOptions.push({
          id: option.id,
          text: option.text,
          placeholder: `Opción ${optIndex + 1}`,
          isAddOption: false,
          isOtherOption: isOtherOption
        });
      });
    }

      const branches = {};
      const existingBranches = {};
      
      if (apiQuestion.branches && apiQuestion.branches.length > 0) {
        
        const branchesByOption = {};
        apiQuestion.branches.forEach(branch => {
          const triggerOptionId = branch.triggerOptionId;
          if (!branchesByOption[triggerOptionId]) {
            branchesByOption[triggerOptionId] = [];
          }
          branchesByOption[triggerOptionId].push(branch);
        });

        Object.entries(branchesByOption).forEach(([triggerOptionId, branchGroup]) => {
          const triggerOption = componentOptions.find(opt => 
            opt.id === parseInt(triggerOptionId) && !opt.isAddOption && !opt.isOtherOption
          );
          
          if (triggerOption) {
            const optionId = triggerOption.id;
            branches[optionId] = [];
            
            branchGroup.forEach((branch, index) => {
              const branchQuestionData = convertBranchToComponentFormat(branch);
              branches[optionId].push({
                id: branch.id,
                data: branchQuestionData,
                order: index + 1
              });
            });
            
            if (branches[optionId].length > 0) {
              existingBranches[optionId] = branches[optionId][0];
            }
          }
        });
      }

      const questionData = {
        id: apiQuestion.id,
        isRequired: apiQuestion.obligatory,
        options: componentOptions,
        selectedOption: null,
        selectedOptions: [],
        uploadedImage: null,
        imagePreview: apiQuestion.image || null,
        questionTitle: apiQuestion.text,
        selectedFormat: selectedFormat,
        branches: branches,
        existingBranches: existingBranches,
        hasOtherOption: apiQuestion.hasOtherOption 
      };

      return {
        id: apiQuestion.id,
        data: questionData,
        order: apiQuestion.order
      };
    });

    return convertedQuestions;
  };

  const convertBranchToComponentFormat = (branch) => {
    
    let selectedFormat;
    switch(branch.formatId) {
      case 1: selectedFormat = 1; break;
      case 2: selectedFormat = 2; break;
      case 3: selectedFormat = 3; break;
      default: selectedFormat = 2;
    }

    const componentOptions = [];
    
  if (branch.options && branch.options.length > 0) {
    branch.options.forEach((option, optIndex) => {
      // Determinar si es opción "Otros" basado en hasOtherOption
      const isOtherOption = branch.hasOtherOption && option.text === "Otros";
      
      componentOptions.push({
        id: option.id, 
        text: option.text,
        placeholder: `Opción ${optIndex + 1}`,
        isAddOption: false,
        isOtherOption: isOtherOption
      });
    });
  }

    const branches = {};
    const existingBranches = {};
    
    if (branch.branches && branch.branches.length > 0) {
      const subBranchesByOption = {};
      branch.branches.forEach(subBranch => {
        const triggerOptionId = subBranch.triggerOptionId;
        if (!subBranchesByOption[triggerOptionId]) {
          subBranchesByOption[triggerOptionId] = [];
        }
        subBranchesByOption[triggerOptionId].push(subBranch);
      });
      
      Object.entries(subBranchesByOption).forEach(([triggerOptionId, subBranchGroup]) => {
        const triggerOption = componentOptions.find(opt => 
          opt.id === parseInt(triggerOptionId) && !opt.isAddOption && !opt.isOtherOption
        );
        
        if (triggerOption) {
          const optionId = triggerOption.id;
          branches[optionId] = [];
          
          subBranchGroup.forEach((subBranch, index) => {
            const subBranchQuestionData = convertBranchToComponentFormat(subBranch);
            branches[optionId].push({
              id: subBranch.id,
              data: subBranchQuestionData,
              order: index + 1
            });
          });
          
          if (branches[optionId].length > 0) {
            existingBranches[optionId] = branches[optionId][0];
          }
        }
      });
    }

    return {
      id: branch.id, 
      isRequired: branch.obligatory,
      options: componentOptions,
      selectedOption: null,
      selectedOptions: [],
      uploadedImage: null,
      imagePreview: branch.image || null,
      questionTitle: branch.text,
      selectedFormat: selectedFormat,
      branches: branches,
      existingBranches: existingBranches,
      hasOtherOption: branch.hasOtherOption  || false
    };
  };

  useEffect(() => {
    const loadSurveyData = async () => {
      try {
        setLoading(true);
        const response = await getSurveyById(surveyId);
        const surveyData = response.data.survey;
        

      surveyData.questions.forEach((q, index) => {
      });
        
        setTitle(surveyData.title);
        setDescription(surveyData.description || '');
        setDateRange({
          startDate: surveyData.opening_At.split('T')[0],
          endDate: surveyData.closing_At.split('T')[0]
        });
        
        const convertedQuestions = convertApiToComponentFormat(surveyData);
        
        convertedQuestions.forEach((q, index) => {
        });
        setQuestions(convertedQuestions);
        
      } catch (error) {
        console.error("Error al cargar la encuesta:", error);
        setErrorMessage("Error al cargar los datos de la encuesta");
        setShowModalAlertWarning(true);
      } finally {
        setLoading(false);
      }
    };

    if (surveyId) {
      loadSurveyData();
    }
  }, [surveyId]);

const updateQuestionData = (questionId, newData) => {

  setQuestions(prevQuestions => 
    prevQuestions.map(question => 
      question.id === questionId 
        ? { 
            ...question, 
            data: {
              ...newData,
              id: question.id,
              hasOtherOption: newData.hasOtherOption !== undefined ? newData.hasOtherOption : question.data.hasOtherOption
            }
          }
        : question
    )
  );
};

  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

const formatQuestionForApi = async (questionData, order = 1, parentId = null, triggerOptionId = null) => {
  

  if (!questionData || !questionData.questionTitle) return null;
    
  const question = {
    Id: questionData.id,
    Text: questionData.questionTitle,
    Obligatory: questionData.isRequired ,
    Order: order,
    FormatId: questionData.selectedFormat ,
    ParentQuestionId: parentId,
    TriggerOptionId: triggerOptionId,
    HasOtherOption: questionData.hasOtherOption
  };


  if (questionData.uploadedImage) {
    try {
      const fullBase64 = await convertImageToBase64(questionData.uploadedImage);
      question.Image = fullBase64.split(',')[1]; 
    } catch (error) {
      console.error("Error convirtiendo imagen a base64:", error);
    }
  }

  if ((questionData.selectedFormat === 2 || questionData.selectedFormat === 3) && questionData.options) {
    const validOptions = questionData.options.filter(opt => {
      if (opt.isAddOption) return false;
      
      if (opt.isOtherOption) {
        return questionData.hasOtherOption === true;
      }
      
      return opt.text && opt.text.trim() !== "";
    });

    question.Options = validOptions.map(opt => ({
      Id: opt.id,
      Text: opt.text.trim()
    }));
  }
    
  if (questionData.branches && Object.keys(questionData.branches).length > 0) {
    question.Branches = [];
    
    for (const [optionId, branchArray] of Object.entries(questionData.branches)) {
      const numericOptionId = parseInt(optionId);
      
      const option = questionData.options.find(opt => 
        opt.id === numericOptionId && 
        !opt.isAddOption && 
        !opt.isOtherOption && 
        opt.text && opt.text.trim() !== ""
      );
      
      if (option && Array.isArray(branchArray)) {
        for (let i = 0; i < branchArray.length; i++) {
          const branch = branchArray[i];
          if (branch && branch.data && branch.data.questionTitle && branch.data.questionTitle.trim() !== "") {
            
            const formattedBranch = await formatQuestionForApi(
              { ...branch.data, id: branch.id }, 
              i + 1, 
              question.Id,
              numericOptionId
            );
            
            if (formattedBranch) {
              formattedBranch.OpenValue = option.text.trim();
              question.Branches.push(formattedBranch);
            }
          }
        }
      }
    }
    
    if (question.Branches.length === 0) {
      delete question.Branches;
    }
  }
    
  return question;
};

const prepareSurveyData = async () => {

  const questionsWithoutId = questions.filter(q => !q.id || !q.data.id);
  if (questionsWithoutId.length > 0) {
    console.error("Preguntas sin ID encontradas:", questionsWithoutId);
    throw new Error("Algunas preguntas no tienen ID válido");
  }

  const formattedQuestions = await Promise.all(
    questions
      .map(async (question, index) => {
        const formatted = await formatQuestionForApi(question.data, index + 1);
        return formatted;
      })
      .filter(question => question !== null)
  );

  const invalidQuestions = formattedQuestions.filter(q => !q.Id);
  if (invalidQuestions.length > 0) {
    console.error("Preguntas formateadas sin ID:", invalidQuestions);
    throw new Error("Error al formatear preguntas: IDs faltantes");
  }


  const surveyData = {
    Title: title,
    Description: description, 
    OpeningAt: dateRange.startDate,
    ClosingAt: dateRange.endDate,
    Questions: formattedQuestions
  };
  
  return surveyData;
};

  const addNewQuestion = () => {
    const newQuestionId = Math.max(...questions.map(q => q.id), 0) + 1;
    setQuestions([...questions, { 
      id: newQuestionId, 
      data: {
        isRequired: false,
        options: [
          { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
          { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
        ],
        selectedOption: null,
        selectedOptions: [],
        uploadedImage: null,
        imagePreview: null,
        questionTitle: "",
        selectedFormat: 2,
        branches: {}
      }, 
      order: questions.length + 1 
    }]);
  };

  const duplicateQuestion = (questionData, questionId) => {
    const newQuestionId = Math.max(...questions.map(q => q.id)) + 1;
    const newQuestions = [...questions];
    
    const currentIndex = newQuestions.findIndex(q => q.id === questionId);
    newQuestions.splice(currentIndex + 1, 0, { 
      id: newQuestionId, 
      data: { ...questionData },
      order: currentIndex + 2
    });
    
    newQuestions.forEach((q, index) => {
      q.order = index + 1;
    });
    
    setQuestions(newQuestions);
  };

  const deleteQuestion = (questionId) => {
    if (questions.length > 1) {
      const newQuestions = questions.filter(q => q.id !== questionId);
      newQuestions.forEach((q, index) => {
        q.order = index + 1;
      });
      setQuestions(newQuestions);
    }
  };

  const handleSaveForm = async () => {

    if (!title.trim()) {
      setErrorMessage("Por favor, ingresa un título para el formulario");
      setShowModalAlertWarning(true);
      return;
    }

    if (!dateRange.startDate || !dateRange.endDate) {
      setErrorMessage("Por favor, selecciona las fechas de inicio y fin");
      setShowModalAlertWarning(true);
      return;
    }

    if (new Date(dateRange.startDate) >= new Date(dateRange.endDate)) {
      setErrorMessage("La fecha de fin debe ser posterior a la fecha de inicio");
      setShowModalAlertWarning(true);
      return;     
    }

    const hasValidQuestions = questions.some(q => 
      q.data && q.data.questionTitle && q.data.questionTitle.trim() !== ""
    );

    if (!hasValidQuestions) {
      setErrorMessage("Por favor, ingresa al menos una pregunta válida");
      setShowModalAlertWarning(true);
      return;
    }

    try {
      setSaving(true);
      const surveyData = await prepareSurveyData();


      const response = await updateSurvey(surveyId, surveyData);
      

      setSuccessMessage("Encuesta actualizada exitosamente");
      setShowModalSuccess(true);
      
      if (onFormSaved) {
        onFormSaved(surveyData);
      }
    } catch (error) {
      console.error("Error al actualizar encuesta:", error);
      let errorMsg = "Error inesperado: " + error.message;
      
      if (error.response) {
        errorMsg = "Error al actualizar la encuesta: " + (error.response.data.message || error.response.statusText);
      } else if (error.request) {
        errorMsg = "Error de conexión. Por favor, verifica tu conexión a internet.";
      }
      
      setErrorMessage(errorMsg);
      setShowModalAlertWarning(true);
    } finally {
      setSaving(false); 
    }
  };

  const handleDateRangeChange = (dates) => {
    setDateRange({
      startDate: dates.startDate,
      endDate: dates.endDate
    });
  };

  const handleWarningModalClose = () => {
    setShowModalAlertWarning(false);
  };

  const handleSuccessModalClose = () => {
    setShowModalSuccess(false);
    navigate("/encuestas");

  };

  if (loading) {
    return (
      <div className="flex items-center justify-center w-full h-64">
        <p className="text-blue font-itcmedium">Cargando encuesta...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-col w-full gap-4 pt-2">
        <div className="flex flex-col items-center justify-between w-full gap-3 md:flex-row">
          <input 
            className="w-full text-2xl bg-transparent outline-none focus:border-b-2 focus:border-blue hover:border-b hover:border-blue text-blue font-itcbook placeholder:text-2xl placeholder:text-blue placeholder:font-itcbook"
            placeholder="Título del formulario *"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            maxLength={50}
          />
          <div className="md:w-[350px]">
            <DateRangeFormField 
              required
              onDateRangeChange={handleDateRangeChange}
              value={dateRange}
            />
          </div>
        </div>

        <input 
          className="text-xl bg-transparent outline-none focus:border-[#6B7280] hover:border-[#6B7280] focus:border-b-2 hover:border-b font-itcbook placeholder:text-xl placeholder:text-[#6B7280] placeholder:font-itcbook "
          placeholder="Descripción del formulario"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          maxLength={200}
        />
  
        {questions.map((question, index) => (
          <QuestionCardAdmin 
            key={question.id}
            questionData={question.data}
            onUpdate={(data) => updateQuestionData(question.id, data)} 
            showDeleteButton={false}
            isEditing={true}
          />
        ))}

        <div className="flex items-center justify-center w-full gap-4">
          <SaveButton
            title={saving ? "Guardando..." : "Guardar Cambios"}
            onClick={handleSaveForm}
            disabled={saving}
          />
          <CancelButton
            onClick={onBack}
            disabled={saving}
          />
        </div>
      </div>

      <ModalAlertWarning
        showModalAlertWarning={showModalAlertWarning}
        closeModal={handleWarningModalClose}
        error={errorMessage}
        accept={handleWarningModalClose}
      />

      <ModalSuccess 
        showModalSuccess={showModalSuccess}
        closeModalSuccess={handleSuccessModalClose}
        fill="green" 
        text={successMessage}
      />
    </div>
  );
};

export default EditFormScreen;